<template>
  <div class="home" ref="maincol">
    <component v-for="(part, name) in content" :key="name" :is="part.type" :content="part" />
  </div>
</template>

<script>
import SimpleText from "../components/partials/SimpleText";
import FeatureList from "../components/partials/FeatureList";
import MediaList from "../components/partials/MediaList";
import content from '../store/content';

export default {
  name: 'home',
  data() {
    return {
      content,
      topOffset: 0
    }
  },
  mounted() {
    this.$bus.$on('setTopNavSpace', (data) => {
      this.topOffset = data.top;
      this.$refs.maincol.style.marginTop = `${data.top}px`;
      this.$refs.maincol.style.paddingBottom = `${data.top + data.height}px`;
    });
    this.$bus.$on('navigateTo', (data) => {
      const elOffset = document.querySelector(`section#${data.name}`).offsetTop;
      window.scrollTo({
        top: elOffset - this.topOffset,
        left: 0,
        behavior: 'smooth'
      });
    })
  },
  components: {
    SimpleText,
    FeatureList,
    MediaList
  },
};
</script>

<style lang="sass" scoped>

</style>
